module.exports = __webpack_public_path__ + "media/recipes/139-ccc389b4.png";